import { render, staticRenderFns } from "./Scholarships.vue?vue&type=template&id=3cffde82&scoped=true&"
import script from "./Scholarships.vue?vue&type=script&lang=js&"
export * from "./Scholarships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cffde82",
  null
  
)

export default component.exports